var HandlebarsHelpers = {
    
    register: function (handlebarsInstance) {
        handlebarsInstance.registerHelper('equals', function (condition1, condition2, matchTypes, options) {
            if (equals(condition1, condition2, matchTypes)) {
                return options.fn(this);
            }

            return options.inverse(this);
        });
        
        handlebarsInstance.registerHelper('differs', function (condition1, condition2, matchTypes, options) {
            if (!equals(condition1, condition2, matchTypes)) {
                return options.fn(this);
            }

            return options.inverse(this);
        });
    }
};

function equals(condition1, condition2, matchTypes) {
    if (matchTypes) {
        if (condition1 === condition2) {
            return true;
        }
    } else {
        if (condition1 == condition2) {
            return true;
        }
    }
    
    return false;
};

module.exports = HandlebarsHelpers;